import {
	pushNextStepEvent,
	pushStartDecisionToolEvent,
	pushViewResultEvent,
} from '@/globals/analytics/events/pushDecisionToolEvent';
import { QuestionTranslation } from './legalForm.config';
import { convertGivenAnswersToSearchParams } from './LegalFormAnalyticsProvider';

const getAnswerTitle = ({
	answerId,
	isPlural,
	question,
}: {
	answerId: string | null;
	isPlural: boolean;
	question: QuestionTranslation;
}) => {
	if (answerId == null || answerId === '') {
		return undefined;
	}

	const answer = question.answers.find((currentAnswer) => {
		return currentAnswer.id === answerId;
	});

	if (answer == null) {
		return undefined;
	}

	return isPlural && answer.text.plural
		? answer.text.plural
		: answer.text.single;
};

export const pushLegalFormSubmitEvents = ({
	givenAnswers,
	hasStartedDecisionTool,
	hasViewedResult,
	isCompletingDecisionTool,
	isPlural,
	onDecisionToolStarted,
	onResultViewed,
	question,
	submittedAnswerId,
}: {
	givenAnswers: Map<string, string | null>;
	hasStartedDecisionTool: boolean;
	hasViewedResult: boolean;
	isCompletingDecisionTool: boolean;
	isPlural: boolean;
	onDecisionToolStarted: () => void;
	onResultViewed: () => void;
	question: QuestionTranslation;
	submittedAnswerId: string | null;
}) => {
	if (!hasStartedDecisionTool) {
		pushStartDecisionToolEvent();
		onDecisionToolStarted();
	}

	pushNextStepEvent({
		answerTitle: getAnswerTitle({
			answerId: submittedAnswerId,
			isPlural,
			question,
		}),
		questionId: question.id,
		questionTitle: question.title,
	});

	if (!isCompletingDecisionTool) {
		return;
	}

	pushViewResultEvent({
		action: hasViewedResult ? 'view_result_midflow' : 'view_result',
		givenAnswersSearchParamsString:
			convertGivenAnswersToSearchParams(givenAnswers).toString(),
	});
	onResultViewed();
};
